import { TicketStatusFilter } from "@iloq/shared";

export const GET_SUPPORT_REQUESTS_QUERY_KEY = "getSupportRequests" as const;

export function buildGetSupportRequestsQueryKey(
  status: TicketStatusFilter = "any",
  term: string = "",
) {
  return [GET_SUPPORT_REQUESTS_QUERY_KEY, status, term] as const;
}
